import { WarrantyLogInput, WarrantyLogService } from 'api-new/generated';
import { QueryError } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';

type WarrantyLogDeleteFile = {
  logId: number;
  fileUid: string;
};
export const useWarrantyLogDeleteFileMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof WarrantyLogService.deleteWarrantyLogDeleteFile>>,
      QueryError,
      WarrantyLogDeleteFile,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation(
    (input: WarrantyLogDeleteFile) => WarrantyLogService.deleteWarrantyLogDeleteFile(input.logId, input.fileUid),
    options
  );
